import type { ParticipantTask } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaAngleDown, FaPencilAlt, FaTrash } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { ParticipantTaskDeleteModal } from './ParticipantTaskDeleteModal';
import { ParticipantTaskEditModal } from './ParticipantTaskEditModal';

interface Props extends ChakraV3.ButtonProps {
  participantTask: ParticipantTask;
}

export const ParticipantTaskActionMenu = (props: Props) => {
  const { participantTask, ...rest } = props;

  return (
    <ChakraV3.Menu.Root lazyMount={true} unmountOnExit={false}>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ChakraV3.MenuItem
            onClick={() => showModal(ParticipantTaskEditModal, { participantTask })}
            value='edit'
          >
            <FaPencilAlt />
            Edit
          </ChakraV3.MenuItem>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(ParticipantTaskDeleteModal, {
                participantTask,
              })
            }
            value='delete'
            color='danger'
          >
            <FaTrash />
            Delete
          </ChakraV3.MenuItem>
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button variant='plain' {...rest}>
          Actions
          <FaAngleDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
    </ChakraV3.Menu.Root>
  );
};
